import { Tooltip } from 'antd';

interface InfoTooltipProps {
  /** The explanatory text shown in the tooltip. */
  content: string;
  /** Accessible label for the trigger button (defaults to "More information"). */
  label?: string;
}

/**
 * A small "?" affordance that reveals explanatory text on hover, click, or
 * keyboard focus. Wraps antd's Tooltip so positioning and accessibility are
 * handled for us. Used beside form labels to explain a question without
 * cluttering the label itself.
 */
export const InfoTooltip = ({ content, label = 'More information' }: InfoTooltipProps) => {
  return (
    <Tooltip title={content} trigger={['hover', 'click', 'focus']}>
      <button
        type="button"
        aria-label={label}
        className="flex h-5 w-5 cursor-help items-center justify-center rounded-full bg-gray-300 text-xs font-bold text-gray-700 hover:bg-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-500"
      >
        ?
      </button>
    </Tooltip>
  );
};
